import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import BookCover from 'rebook/apps/books/components/BookCover';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import { Book } from 'rebook/apps/books/models';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';

import styles from './style.scss';


class DashboardRecoBlock extends React.Component {
  constructor(props) {
    super(props);
    this.bookLimit = 10;
    const { block } = props;
    const blockId = `${block.id}-${block.type}`;

    this.state = {
      block: props.block,
      blockId,
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchBookList();
  }

  fetchBookList() {
    const { block, blockId } = this.state;
    const { dashboardBlockList } = this.props;

    if (dashboardBlockList[blockId]) {
      return null;
    }

    const url = fixQueryString(block.resource_uri, { limit: this.bookLimit });
    this.props.DashboardBlockListActions.fetchDashboardBlock(url, { apiVersion: 3 })
      .then(
        ({ data, dispatch }) => {
          // endpoint may return either plain list or paginated response
          dispatch({
            type: DASHBOARD_BLOCK_SET_DATA,
            payload: {
              [blockId]: {
                books: data.objects ? data.objects : data,
                bookCountTotal: data.meta ? data.meta.total_count : null,
              },
            },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to fetch dashboard books due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
        }
      );
  }

  render() {
    const { blockId } = this.state;
    const { user, title, dashboardBlockList } = this.props;

    return (
      <div className={styles.container}>
        {user
          ? (
            <div className={styles.user}>
              <CroppedImage src={user.avatar} width={32} height={32} className={styles.avatar} />
              <div className={styles.title}>{title ? title : 'Ваши персональные рекоммендации'}</div>
            </div>
          )
          : (<div className={styles.titleAnon}>{'Рекомендуем'}</div>)
        }
        <ContentCarousel>
          {get(dashboardBlockList[blockId], 'books.length', 0)
            ? (
              dashboardBlockList[blockId].books.map((book) => (
                <div key={book.id} className={styles.item}>
                  <BookCover book={new Book(book)} width={124} height={196} />
                </div>
              ))
            )
            : ([...Array(5)].map((item, idx)=> (<div className={styles.emptyItem} key={`emtyReco${idx}`} />)))
          }
        </ContentCarousel>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    dashboardBlockList: state.dashboardBlockList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
  };
};


DashboardRecoBlock.propTypes = {
  user: PropTypes.object,
  block: PropTypes.shape({
    title: PropTypes.string.isRequired,
    resource_uri: PropTypes.string.isRequired,
  }).isRequired,
};

DashboardRecoBlock.defaultProps = {
  user: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardRecoBlock);
